import React, { useState, useEffect } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Text,
} from '@chakra-ui/react'

interface BatchImportModalProps {
  isOpen: boolean
  onClose: () => void
  onImport: (text: string) => void
  title: string
  placeholder?: string
  helperText?: string
  label?: string
}

export const BatchImportModal: React.FC<BatchImportModalProps> = ({
  isOpen,
  onClose,
  onImport,
  title,
  placeholder,
  helperText,
  label,
}) => {
  const [text, setText] = useState('')

  // Reset text when modal opens
  useEffect(() => {
    if (isOpen) {
      setText('')
    }
  }, [isOpen])

  const handleImport = () => {
    onImport(text)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            {label && <FormLabel>{label}</FormLabel>}
            <Textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder={placeholder}
              rows={10}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleImport}>
            Import
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

